// extracted by mini-css-extract-plugin
export var carousel = "index-module--carousel--3e340";
export var grid = "index-module--grid--97cd0";
export var photos = "index-module--photos--41764";
export var tools = "index-module--tools--e1ed8";